import React, {useState} from 'react'
import {Button} from '../../../../../core/shared/Button'
import {getPriceForCountry} from '../../../utils/getPriceForCountry'
import {IncludeOnboardingToggle} from '../../../../../components/catalog-components/include-onboarding-toggle'
import {AddToOrderRow} from '../ProductPlanSelector.styles'

export function GrowthPackagePanel({
  plan,
  selectedCountry,
  groupPlanCodes,
  groupId,
  showGrowthPackageOnboarding,
  onAddProduct,
  onClose,
}) {
  const [includeOnboarding, setIncludeOnboarding] = useState({value: 'No'})

  const handleAddToOrder = () => {
    onAddProduct(
      {
        productId: plan.code,
        name: plan.name,
        price: getPriceForCountry(plan.currencies, selectedCountry),
        productType: 'APP',
        billingFrequency:
          plan.productBillingType === 'Annual' ? 'annual' : 'monthly',
        quantity: 1,
        configuredOptions: showGrowthPackageOnboarding
          ? {includeOnboarding}
          : {},
        excludes: plan.excludes ?? [],
        autoAddCenters: plan.autoAddCenters ?? [],
        disableApps: plan.disableApps ?? [],
        disableCenters: plan.disableCenters ?? [],
        maxQty: plan.maxQty ?? null,
        productRank: plan.productRank ?? null,
        downgrades: plan.downgrades ?? [],
        parentProduct: plan.parentProduct,
      },
      groupPlanCodes,
      groupId,
    )
    onClose()
  }

  return (
    <>
      {showGrowthPackageOnboarding && (
        <IncludeOnboardingToggle
          includeOnboarding={includeOnboarding}
          setIncludeOnboarding={setIncludeOnboarding}
        />
      )}
      <AddToOrderRow>
        <Button
          type="button"
          variant="action-orange"
          size="sm"
          onClick={handleAddToOrder}
        >
          Add to Order
        </Button>
      </AddToOrderRow>
    </>
  )
}
